<div class="marker-container" [class.mobile]="isMobile()" [class.wide]="wide()">
  <img
    nz-image
    nzDisablePreview
    [nzSrc]="image() ?? ''"
    (load)="onImageLoaded($event)"
  />

  <div class="marker-boundary">
    @for (marker of markers(); track marker) {
      <div
        class="marker"
        cdkDragBoundary=".marker-boundary"
        cdkDrag
        [cdkDragFreeDragPosition]="getDragPosition(marker)"
        (cdkDragEnded)="onDragEnded(marker, $event)"
      >
        <i nz-icon nzType="icons:marker-sensor" class="svgIcon"></i>
        <div class="span-wrapper">
          <span [class.smallFont]="marker.label.length > 3">
            {{ marker.label }}
          </span>
        </div>
      </div>
    }
  </div>
</div>
